import Proptypes from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";

const RecordConfirmationModal = ({ show, closeModal, onClickRecord }) => (
  <Modal
    className="tw-flex tw-items-center tw-justify-center"
    containerClassName="!tw-z-[3001]"
    contentClassName="tw-max-w-[560px] tw-flex tw-flex-col tw-gap-[32px]"
    show={show}
  >
    <Modal.Header title="Inform the other party of recording" />
    <Modal.Body>
      <div className="tw-shadow-card tw-py-[54px] tw-flex tw-justify-center tw-items-center tw-border-[1px] tw-border-solid tw-border-gray-10 tw-rounded-[20px]">
        <p className="tw-text-18d tw-font-semibold tw-m-0">&quot;Do you mind if I record this call?&quot;</p>
      </div>
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-flex-row tw-justify-between">
      <Button schema="tertiary" size="medium" onClick={closeModal}>
        Don&apos;t Record
      </Button>

      <Button schema="primary" size="medium" onClick={onClickRecord}>
        Yes, I have informed them
      </Button>
    </Modal.Footer>
  </Modal>
);

RecordConfirmationModal.propTypes = {
  show: Proptypes.bool,
  closeModal: Proptypes.func,
  onClickRecord: Proptypes.func.isRequired,
};

RecordConfirmationModal.defaultProps = {
  show: false,
  closeModal: null,
};

export default RecordConfirmationModal;
